import { Link } from "react-router-dom";
import { brandAssets, company, navigation } from "@/mocks/site";

const productLinks = [
  { label: "Sondermaschinenbau", href: "/produkte#sondermaschinen" },
  { label: "Stellplatzausstattung", href: "/produkte#stellplatzausstattung" },
  { label: "E-Ladestationen", href: "/produkte#e-ladestationen" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-foreground-950 text-background-300">
      <div className="h-[3px] w-full bg-primary-500" />
      <div className="relative overflow-hidden">
        <div className="blueprint absolute inset-0 opacity-40" />
        <div className="relative mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
            <div className="lg:col-span-4">
              <img
                src={brandAssets.bannerLogo}
                alt={company.name}
                width={974}
                height={170}
                className="mb-6 h-auto w-full max-w-[290px] object-contain"
              />
              <p className="max-w-sm text-[14px] leading-relaxed text-background-400">
                Familienbetrieb in dritter Generation. Sondermaschinen, Edelstahl-Anlagen für
                Stellplätze und Ladestationen — gefertigt in Obertrubach-Geschwand.
              </p>
              <p className="mt-5 font-label text-[11px] uppercase tracking-[0.2em] text-primary-400">
                {company.motto}
              </p>
            </div>

            <div className="lg:col-span-2">
              <h3 className="mb-4 font-label text-[10.5px] uppercase tracking-[0.22em] text-background-500">
                Navigation
              </h3>
              <ul className="flex flex-col gap-2.5">
                {navigation.map((item) => (
                  <li key={item.href}>
                    <Link
                      to={item.href}
                      className="text-[14px] text-background-300 transition-colors hover:text-primary-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-3">
              <h3 className="mb-4 font-label text-[10.5px] uppercase tracking-[0.22em] text-background-500">
                Produkte
              </h3>
              <ul className="flex flex-col gap-2.5">
                {productLinks.map((item) => (
                  <li key={item.href}>
                    <Link
                      to={item.href}
                      className="text-[14px] text-background-300 transition-colors hover:text-primary-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-3">
              <h3 className="mb-4 font-label text-[10.5px] uppercase tracking-[0.22em] text-background-500">
                Kontakt
              </h3>
              <address className="not-italic text-[14px] leading-relaxed text-background-300">
                {company.street}
                <br />
                D-{company.zip} {company.city}
              </address>
              <div className="mt-4 flex flex-col gap-2 font-label text-[12.5px]">
                <a
                  href={`tel:${company.phoneHref}`}
                  className="flex items-center gap-2 text-background-300 transition-colors hover:text-primary-300"
                >
                  <i className="ri-phone-line text-[13px] text-primary-500" />
                  {company.phone}
                </a>
                <a
                  href={`mailto:${company.email}`}
                  className="flex items-center gap-2 text-background-300 transition-colors hover:text-primary-300"
                >
                  <i className="ri-mail-line text-[13px] text-primary-500" />
                  {company.email}
                </a>
              </div>
              <div className="mt-4 font-label text-[11.5px] leading-relaxed text-background-500">
                Mo – Do 06:30 – 12:00 / 12:45 – 16:00
                <br />
                Fr 06:30 – 11:30
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="mx-auto flex w-full max-w-shell flex-col gap-3 px-4 py-5 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p className="font-label text-[11px] tracking-[0.04em] text-background-500">
            © {new Date().getFullYear()} {company.name}
          </p>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2 font-label text-[11px] uppercase tracking-[0.12em]">
            <Link to="/impressum" className="text-background-400 transition-colors hover:text-primary-300">
              Impressum
            </Link>
            <span className="text-background-700">/</span>
            <Link to="/datenschutz" className="text-background-400 transition-colors hover:text-primary-300">
              Datenschutz
            </Link>
            <span className="text-background-700">/</span>
            <Link to="/kontakt" className="text-background-400 transition-colors hover:text-primary-300">
              Kontakt
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}